/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Checkin_HintInputs */

const en_us2_profile_checkin_hint = /** @type {(inputs: Profile_Checkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How sore you are the next day`)
};

const pt_br2_profile_checkin_hint = /** @type {(inputs: Profile_Checkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está a dor muscular no dia seguinte`)
};

const es_419_profile_checkin_hint = /** @type {(inputs: Profile_Checkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué tan adolorido estás al día siguiente`)
};

const pt_pt2_profile_checkin_hint = /** @type {(inputs: Profile_Checkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como estão as dores musculares no dia seguinte`)
};

const fr_fr2_profile_checkin_hint = /** @type {(inputs: Profile_Checkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes courbatures le lendemain`)
};

const de_de2_profile_checkin_hint = /** @type {(inputs: Profile_Checkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie stark dein Muskelkater am nächsten Tag ist`)
};

const it_it2_profile_checkin_hint = /** @type {(inputs: Profile_Checkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto sei indolenzito il giorno dopo`)
};

/**
* | output |
* | --- |
* | "How sore you are the next day" |
*
* @param {Profile_Checkin_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_checkin_hint = /** @type {((inputs?: Profile_Checkin_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Checkin_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_checkin_hint(inputs)
	if (locale === "es-419") return es_419_profile_checkin_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_checkin_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_checkin_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_checkin_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_checkin_hint(inputs)
	return en_us2_profile_checkin_hint(inputs)
});
export { profile_checkin_hint as "profile.checkin_hint" }